import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { CreatingOrderSelectors } from 'store/selectors';
import OrderSummary from 'components/creatingOrder/OrderSummary/OrderSummary';

const orderSummarySelector = createStructuredSelector({
  tickets: CreatingOrderSelectors.getTicketEntities,
  addons: CreatingOrderSelectors.getAddonEntities,
  ticketsCounts: CreatingOrderSelectors.getTicketItemsCounts,
  addonsCounts: CreatingOrderSelectors.getAddonsItemsCounts,
  totalTicketsCount: CreatingOrderSelectors.getTotalTicketsCount,
  totalAddonsCount: CreatingOrderSelectors.getTotalAddonsCount,
  totalTicketsPrice: CreatingOrderSelectors.getTotalTicketsPrice,
  totalAddonsPrice: CreatingOrderSelectors.getTotalAddonsPrice,
  totalDonations: CreatingOrderSelectors.getTotalDonations,
  totalDiscount: CreatingOrderSelectors.getTotalDiscount,
  totalPrice: CreatingOrderSelectors.getTotalPrice,
  taxes: CreatingOrderSelectors.getTotalTaxes,
  currency: CreatingOrderSelectors.getDefaultCurrency,
});

interface IProps {
  notExpandable?: boolean;
}

const OrderSummaryContainer: React.FC<React.PropsWithChildren<IProps>> = ({ notExpandable }) => {
  const state = useSelector(orderSummarySelector);
  return <OrderSummary notExpandable={notExpandable} {...state} />;
};

export default memo(OrderSummaryContainer);
